import { Grid, LinearProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { ApplicationState } from "../../../store";
import { FileHeader } from "./FileHeader";
import * as GalleryStore from "../../../store/Gallery";
import { connect, ConnectedProps } from "react-redux";

export interface SingleFileUploadWithProgressProps extends PropsFromRedux {
  file: File;
  onDelete: (file: File) => void;
  onUpload: (file: File, url: string) => void;
  token: string;
  uploadImage: (acceptedFile: File) => void;
}

const SingleFileUploadWithProgress: React.FC<
  SingleFileUploadWithProgressProps
> = ({ file, onDelete, onUpload, token }) => {
  const [progress, setProgress] = useState(0);

  const uploadFile = (file: File, onProgress: (percentage: number) => void) =>
    new Promise<App.Result>((res, rej) => {
      const xhr = new XMLHttpRequest();

      const url =
        process.env.NODE_ENV === "development"
          ? "https://localhost:44314/"
          : "";
      xhr.open("POST", `${url}api/images`);
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);

      xhr.onload = () => {
        res(JSON.parse(xhr.responseText) as App.Result);
      };
      xhr.onerror = (evt) => {
        rej(evt);
      };
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const percentage = (event.loaded / event.total) * 100;
          onProgress(Math.round(percentage));
        }
      };

      const formData = new FormData();
      formData.append("formFile", file);
      xhr.send(formData);
    });

  useEffect(() => {
    const upload = async () => {
      const result = await uploadFile(file, setProgress);
      onUpload(file, result.value as unknown as string);
    };

    if (progress === 0) {
      upload();
    }
  }, []);

  return (
    <Grid item>
      <FileHeader file={file} onDelete={onDelete} />
      <LinearProgress variant="determinate" value={progress} />
    </Grid>
  );
};

const mapStateToProps = (state: ApplicationState) => ({
  token: state.user?.user.token ?? "",
});

const mapDispatch = {
  uploadImage: (acceptedFile: File) =>
    GalleryStore.actionCreators.uploadImages(acceptedFile),
};

const connector = connect(mapStateToProps, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(SingleFileUploadWithProgress);
